/**
 * Created by i.lovenkov on 26.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    QuantityProductView: {
        displayName: 'QuantityProductView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/QuantityProduct/default/QuantityProductView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var QuantityProductView = _wrapComponent('QuantityProductView')(function (_Component) {
    (0, _inherits3.default)(QuantityProductView, _Component);

    function QuantityProductView() {
        (0, _classCallCheck3.default)(this, QuantityProductView);
        return (0, _possibleConstructorReturn3.default)(this, (QuantityProductView.__proto__ || (0, _getPrototypeOf2.default)(QuantityProductView)).apply(this, arguments));
    }

    (0, _createClass3.default)(QuantityProductView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                onClickMinus = _props.onClickMinus,
                onClickPlus = _props.onClickPlus,
                value = _props.value,
                checkValue = _props.checkValue,
                checkCount = _props.checkCount,
                lang = _props.lang;

            if (checkCount < 0) {
                checkCount = 0;
            }
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'le-quantity' },
                    _react3.default.createElement(
                        'form',
                        null,
                        _react3.default.createElement('a', { className: 'minus', onClick: onClickMinus, style: { cursor: 'pointer' } }),
                        _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: value }),
                        _react3.default.createElement('a', { className: 'plus', onClick: onClickPlus, style: { cursor: 'pointer' } })
                    )
                ),
                checkValue && value > checkCount ? _react3.default.createElement(
                    'div',
                    { className: 'basket_item_error' },
                    _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
                    lang['store.common.available_in_stock'],
                    ' ',
                    checkCount
                ) : null
            );
        }
    }]);
    return QuantityProductView;
}(_react2.Component));

exports.default = QuantityProductView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuantityProduct/default/QuantityProductView.jsx
// module id = 1743
// module chunks = 0